import React, { useState } from 'react';
import { Search, Sparkles } from 'lucide-react';

interface SearchBoxProps {
  onSearch: (query: string) => void;
  isSearching: boolean;
  language: 'zh' | 'en';
  examples: string[];
}

export default function SearchBox({ onSearch, isSearching, language, examples }: SearchBoxProps) {
  const [query, setQuery] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim()) {
      onSearch(query.trim());
    }
  };

  const handleExampleClick = (example: string) => {
    setQuery(example);
    onSearch(example);
  };

  return (
    <div className="w-full max-w-4xl mx-auto">
      {/* 搜索框 */}
      <form onSubmit={handleSubmit} className="relative">
        <div className="relative flex items-center">
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={language === 'zh' ? '例如：适合情侣周末看的浪漫电影' : 'e.g., Romantic movies for a weekend date'}
            className="w-full px-6 py-4 pr-32 text-lg bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-700 rounded-2xl focus:outline-none focus:border-orange-400 dark:focus:border-orange-600 transition-colors text-gray-800 dark:text-gray-200 shadow-lg"
            disabled={isSearching}
          />
          <button
            type="submit"
            disabled={isSearching || !query.trim()}
            className="absolute right-2 px-6 py-3 bg-gradient-to-r from-orange-500 to-amber-600 hover:from-orange-600 hover:to-amber-700 disabled:from-gray-400 disabled:to-gray-500 text-white font-medium rounded-xl transition-all duration-200 shadow-md hover:shadow-lg disabled:cursor-not-allowed flex items-center gap-2"
          >
            {isSearching ? (
              <>
                <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                {language === 'zh' ? '搜索中...' : 'Searching...'}
              </>
            ) : (
              <>
                <Search className="w-5 h-5" />
                {language === 'zh' ? '搜索' : 'Search'}
              </>
            )}
          </button>
        </div>
      </form>

      {/* 示例搜索 */}
      {examples.length > 0 && (
        <div className="mt-6 flex flex-wrap justify-center gap-2">
          <span className="text-sm text-gray-500 dark:text-gray-400 flex items-center gap-1">
            <Sparkles className="w-4 h-4" />
            {language === 'zh' ? '试试这些：' : 'Try these:'}
          </span>
          {examples.map((example, index) => (
            <button
              key={index}
              onClick={() => handleExampleClick(example)}
              className="px-4 py-2 text-sm bg-white dark:bg-gray-800 hover:bg-orange-50 dark:hover:bg-orange-900/20 text-gray-700 dark:text-gray-300 hover:text-orange-600 dark:hover:text-orange-400 rounded-lg border border-gray-200 dark:border-gray-700 hover:border-orange-300 dark:hover:border-orange-700 transition-all duration-200 shadow-sm hover:shadow-md"
            >
              {example}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
